import type { ComponentProps, ComponentType } from "react";
import styled from "styled-components";

import {
  DialogHeader,
  FormControl,
  DialogFooter,
  hexWithAlpha,
  Button,
} from "@p2l/ui-public";
import { FontAwesomeIcon } from "@p2l/icons";

export const DialogTitleWrapper: ComponentType<ComponentProps<typeof DialogHeader>> = styled(DialogHeader)`
  padding: 24px 16px;
`;

export const DialogContent: ComponentType<ComponentProps<"div">> = styled.div`
  padding: 0 16px;
`;

export const StyledFormControl = styled(FormControl)`
  margin: 24px 0;
`;

export const StyledDialogFooter = styled(DialogFooter)`
  display: flex;
  justify-content: space-between;
  padding: 16px;
`;

export const SuccessBodyWrapper: ComponentType<ComponentProps<"div">> = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const StyledSuccessMessage: ComponentType<ComponentProps<"p">> = styled.p`
  margin: 16px 0;
`;

export const StyledFAIcon: ComponentType<ComponentProps<typeof FontAwesomeIcon>> = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.components.link.color};
`;
